/* eslint-disable camelcase */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  HrActionText,
  HrFlexContainer,
  HrRed,
  HrPrimary,
  Separate,
  HrRedHover,
  Phone
} from '@components/styles/hr-styles';
import styled from 'styled-components';
import { isEqual } from 'lodash';
import { Input } from '@components/form/input';
import { SelectForm } from '@components/form/select';
import { SelectDateCustom } from '@components/form/select/select-date';
import { Checkbox } from '@components/form/checkbox';
import { Textarea } from '@components/form/textarea';
import { buildSelectOptions } from '../../../utils/form';
import { getDeviceBreakpoint } from '../../../components/utilities/utilities';
import { vacancyRequirementType } from '../../../constant/vacancy-requirement';
import { DisplaySettingsContext } from '../../store/display-settings';
// #region styled
const Grid = styled.div`
  display: grid;
  gap: 24px;
  padding: 0 32px;
  box-sizing: border-box;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  /* grid-template-rows: repeat(5, auto); */
  grid-template-areas:
    'area-1 area-2 area-3'
    'area-4 area-4 area-4'
    'area-5 area-5 area-5'
    'area-6 area-6 area-6';

  & .area-4 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* grid-template-rows: repeat(1, auto); */
    grid-auto-flow: row;
    gap: 24px;
    grid-template-areas: 'area-4-1 area-4-2';
    grid-area: area-4;
  }

  & .area-5 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* grid-template-rows: repeat(1, auto); */
    grid-auto-flow: row;
    gap: 24px;
    grid-template-areas: 'area-5-1 area-5-2';
    grid-area: area-5;
  }

  & .area-6 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* grid-template-rows: repeat(3, auto); */
    grid-auto-flow: row;
    gap: 24px;
    grid-template-areas:
      'area-6-1 area-6-4 area-6-4'
      'area-6-2 area-6-4 area-6-4'
      'area-6-3 area-6-4 area-6-4';
    grid-area: area-6;
  }

  & .area-1 {
    grid-area: area-1;
  }
  & .area-2 {
    grid-area: area-2;
  }
  & .area-3 {
    grid-area: area-3;
  }

  & .area-4-1 {
    grid-area: area-4-1;
  }

  & .area-4-2 {
    grid-area: area-4-2;
  }

  & .area-5-1 {
    grid-area: area-5-1;
  }

  & .area-5-2 {
    grid-area: area-5-2;
  }

  & .area-6-1 {
    grid-area: area-6-1;
  }

  & .area-6-2 {
    grid-area: area-6-2;
  }

  & .area-6-3 {
    grid-area: area-6-3;
  }

  & .area-6-4 {
    grid-area: area-6-4;
  }

  & .area-6-5 {
    grid-area: area-6-5;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
    /* grid-template-columns: repeat(1, 1fr); */
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      'area-1 area-1'
      'area-2 area-3'
      'area-4 area-4'
      'area-5 area-5'
      'area-6 area-6';

    & .area-4 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      /* grid-template-rows: repeat(1, auto); */
      grid-auto-flow: row;
      gap: 24px;
      grid-template-areas: 'area-4-1  area-4-2';
      grid-area: area-4;
    }

    & .area-5 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      /* grid-template-rows: repeat(1, auto); */
      grid-auto-flow: row;
      gap: 24px;
      grid-template-areas: 'area-5-1 area-5-2';
      grid-area: area-5;
    }

    & .area-6 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      /* grid-template-rows: repeat(2, auto); */
      grid-auto-flow: row;
      gap: 24px;
      grid-template-areas:
        'area-6-1 area-6-3'
        'area-6-2 area-6-2'
        'area-6-4 area-6-4';
      grid-area: area-6;
    }
  }
  @media (max-width: ${Phone}) {
    grid-template-columns: repeat(1, 1fr);
    /* grid-template-rows: repeat(auto, auto); */
    grid-template-areas:
      'area-1'
      'area-2'
      'area-3'
      'area-4'
      'area-5'
      'area-6';

    & .area-4 {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      /* grid-template-rows: repeat(1, auto); */
      grid-auto-flow: row;
      gap: 24px;
      grid-template-areas:
        'area-4-1'
        'area-4-2';
      grid-area: area-4;
    }

    & .area-5 {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      /* grid-template-rows: repeat(1, auto); */
      grid-auto-flow: row;
      gap: 24px;
      grid-template-areas:
        'area-5-1'
        'area-5-2';
      grid-area: area-5;
    }

    & .area-6 {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      /* grid-template-rows: repeat(2, auto); */
      grid-auto-flow: row;
      gap: 24px;
      grid-template-areas:
        'area-6-1'
        'area-6-2'
        'area-6-3'
        'area-6-4';
      grid-area: area-6;
    }
  }
`;

const Flex = styled(HrFlexContainer)`
  @media (max-width: 425px) {
    padding: 0 16px;
  }
`;

const Addbutton = styled(HrActionText)`
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px`};
  color: ${HrPrimary};
  margin-left: 32px !important;
  @media (max-width: 768px) {
    margin-left: 16px !important;
  }
`;

// #endregion styled

const postDefault = {
  job: '',
  seniority: null,
  company: '',
  locality: null,
  from_month: null,
  from_year: null,
  to_month: null,
  to_year: null,
  area: null,
  subarea: null,
  industry: null,
  descript: '',
  actual_job: false
};

export const SectionPost = ({
  vacancyRequirement,
  countries,
  bunAreas,
  bunSubAreas,
  seniorities,
  industries,
  register,
  formState,
  control,
  setValue,
  unregister,
  getValues,
  postulant,
  action
}) => {
  const [t] = useTranslation();
  const [posts, setPosts] = useState(null);
  const { posts: _posts } = postulant;

  useEffect(() => {
    const postPustulant = _posts ?? [];
    let currentPost = action !== 'edit' ? JSON.parse(JSON.stringify(getValues('posts') || [])) : [];
    const filterDataEmpty = currentPost.filter((educ) => {
      return !isEqual(educ, postDefault);
    });
    if (filterDataEmpty.length === 0) {
      currentPost = [];
    }
    const postsAll = postPustulant.concat(currentPost);
    // postsAll = orderBy(
    //   postPustulant,
    //   [
    //     (e) => {
    //       return e.to_year || ''; // condicion por si es null el valor
    //     }
    //   ],
    //   ['desc']
    // );
    const edu = postsAll.map((e, index) => {
      Object.keys(e).forEach((key) => {
        setValue(`posts.${index}.${key}`, e[key]);
      });
      return {
        position: index,
        delete: !(vacancyRequirement.jobs === vacancyRequirementType.mandatory && index === 0)
      };
    });

    if (edu.length === 0 && vacancyRequirement.jobs === vacancyRequirementType.mandatory) {
      setPosts([{ position: 1, delete: false }]);
    } else {
      setPosts(edu);
    }
  }, [_posts]);

  const handleAddEducation = () => {
    const cloneitems = JSON.parse(JSON.stringify(posts));
    cloneitems.push({
      position: cloneitems.length || 0,
      delete: !(cloneitems.length === 0 && vacancyRequirement.jobs === vacancyRequirementType.mandatory)
    });
    setPosts(cloneitems);
  };

  const handleDeleteEducation = (position) => {
    const cloneitem = JSON.parse(JSON.stringify(posts));
    const dataFilter = cloneitem.filter((d, index) => {
      return index !== position;
    });

    let edus = JSON.parse(JSON.stringify(getValues('posts'))) || [];
    edus.forEach((e, index) => {
      unregister(`posts.${index}`);
    });
    edus = edus.filter((d, index) => {
      return position !== index;
    });
    edus.forEach((e, index) => {
      Object.keys(e).forEach((key) => {
        const _data = e[key];
        if (_data) {
          setValue(`posts.${index}.${key}`, _data);
        }
      });
    });
    // unregister(`posts.${posts.length}`);
    setPosts(dataFilter);
  };
  const { fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <>
      {posts &&
        posts.map((e, index) => {
          return (
            <div key={`edu_${index}`} style={{ width: '100%' }}>
              {posts.length >= 2 && index > 0 && (
                <Flex padding='0 32px 16px 0'>
                  <Separate />
                </Flex>
              )}

              <Grid>
                <div className='area-1'>
                  <Input
                    title={t('postulant.post.job')}
                    placeholder={t('postulant.post.placeholder.job')}
                    name={`posts.${index}.job`}
                    type='text'
                    register={register}
                    formState={formState}
                    validate={{
                      required: vacancyRequirement.jobs === vacancyRequirementType.mandatory,
                      whiteSpace: true
                    }}
                    errorPosition='bottom'
                    handlerOnBlur={(e) => {
                      setValue(`posts.${index}.job`, e.target.value);
                    }}
                  />
                </div>

                <div className='area-2'>
                  <SelectForm
                    title={t('postulant.post.seniority')}
                    id={`posts.${index}.seniority`}
                    data={seniorities}
                    control={control}
                    formState={formState}
                    isSearchable
                    validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
                    disabled={seniorities.length === 0}
                    errorPosition='bottom'
                  />
                </div>

                <div className='area-3'>
                  <Input
                    title={t('postulant.post.company')}
                    placeholder={t('postulant.post.placeholder.company')}
                    name={`posts.${index}.company`}
                    type='text'
                    register={register}
                    formState={formState}
                    validate={{
                      required: vacancyRequirement.jobs === vacancyRequirementType.mandatory,
                      whiteSpace: false
                    }}
                    errorPosition='bottom'
                    handlerOnBlur={(e) => {
                      setValue(`posts.${index}.company`, e.target.value);
                    }}
                  />
                </div>

                <div className='area-4'>
                  <div className='area-4-1'>
                    <SelectForm
                      title={t('postulant.post.locality')}
                      id={`posts.${index}.locality`}
                      data={countries}
                      control={control}
                      formState={formState}
                      isSearchable
                      validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
                      disabled={countries.length === 0}
                      errorPosition='bottom'
                    />
                  </div>
                  <div className='area-4-2'>
                    <SelectForm
                      title={t('postulant.post.industry')}
                      id={`posts.${index}.industry`}
                      data={industries}
                      control={control}
                      formState={formState}
                      isSearchable
                      validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
                      disabled={industries.length === 0}
                      errorPosition='bottom'
                    />
                  </div>
                </div>

                <SectionArea
                  vacancyRequirement={vacancyRequirement}
                  bunAreas={bunAreas}
                  bunSubAreas={bunSubAreas}
                  getValues={getValues}
                  setValue={setValue}
                  control={control}
                  index={index}
                  formState={formState}
                />

                <div className='area-6'>
                  <div className='area-6-1'>
                    <SelectDateCustom
                      title={t('postulant.post.from_date')}
                      ids={{ year: `posts.${index}.from_year`, month: `posts.${index}.from_month` }}
                      control={control}
                      formState={formState}
                      isSearchable
                      validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
                      errorPosition='bottom'
                    />
                  </div>
                  <StateJobDate
                    index={index}
                    control={control}
                    formState={formState}
                    unregister={unregister}
                    setValue={setValue}
                    vacancyRequirement={vacancyRequirement}
                    posts={_posts}
                  />
                  <div className='area-6-4'>
                    <Textarea
                      title={t('postulant.post.descript')}
                      id={`posts.${index}.descript`}
                      control={control}
                      formState={formState}
                      placeholder={t('postulant.post.placeholder.descript')}
                      minHeight='156px'
                      errorPosition='bottom'
                      validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
                    />
                  </div>
                </div>
              </Grid>
              {e.delete === true && (
                <HrFlexContainer width='100%' justifyContent='flex-end' padding='0 32px 0px 0' margin='16px 0 0 0'>
                  <HrActionText
                    alignItems='center'
                    onClick={() => {
                      handleDeleteEducation(index);
                    }}
                    color={HrRed}
                    colorHover={HrRedHover}
                    fontSize='14px'
                  >
                    <span style={{ fontSize: `${14 + fontSizeSetting || 0}px` }} className='hr-Trash' color={HrRed} />
                    <span style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}>{t('general.button.delete')}</span>
                  </HrActionText>
                </HrFlexContainer>
              )}
            </div>
          );
        })}
      <Addbutton fontSizeSetting={fontSizeSetting} onClick={handleAddEducation}>
        {t('postulant.post.add')}
      </Addbutton>
    </>
  );
};
export const StateJobDate = ({ index, control, formState, unregister, setValue, vacancyRequirement, posts = [] }) => {
  const [toDateDisabled, setToDateDisabled] = useState(false);
  const [t] = useTranslation();

  const post = posts[index] || {};
  const { actual_job } = post;

  useEffect(() => {
    if (actual_job) {
      setToDateDisabled(true);
      unregister(`posts.${index}.to_year`);
      unregister(`posts.${index}.to_month`);
    }
  }, [actual_job]);

  const handleCheckActualPost = (e, position, type) => {
    if (type === 'actual_job' && e.target.checked === true) {
      unregister(`posts.${position}.to_year`);
      unregister(`posts.${position}.to_month`);
      // setValue(`posts.${position}.to_year`, null);
      // setValue(`posts.${position}.to_month`, null);
      setToDateDisabled(true);
    } else {
      setValue(`posts.${position}.actual_job`, false);
      setToDateDisabled(false);
    }
  };

  const checkboxHTML = () => {
    const post = posts[index] || {};
    const { actual_job = false } = post;
    const ref = useRef(`posts.${index}.actual_job`);
    return (
      <div className='area-6-2'>
        <Checkbox
          label={t('postulant.post.actual_job')}
          name={`posts.${index}.actual_job`}
          refCustom={ref}
          control={control}
          onChange={(e) => {
            handleCheckActualPost(e, index, 'actual_job');
          }}
          defaultChecked={actual_job}
        />
      </div>
    );
  };

  return (
    <>
      {getDeviceBreakpoint().device === 'pc' && checkboxHTML(index, control, handleCheckActualPost)}
      <div className='area-6-3'>
        <SelectDateCustom
          title={t('postulant.post.to_date')}
          ids={{ year: `posts.${index}.to_year`, month: `posts.${index}.to_month` }}
          control={control}
          formState={formState}
          isSearchable
          disabled={toDateDisabled}
          validate={{
            required: vacancyRequirement.jobs === vacancyRequirementType.mandatory && !toDateDisabled
          }}
          errorPosition='bottom'
        />
      </div>
      {getDeviceBreakpoint().device !== 'pc' && checkboxHTML(index, control, handleCheckActualPost)}
    </>
  );
};

const SectionArea = ({ vacancyRequirement, index, getValues, control, formState, bunAreas, bunSubAreas }) => {
  const [subarea, setSubareas] = useState([]);
  const [t] = useTranslation();
  const filterSubAreas = (_area) => {
    const dataFilter = bunSubAreas.filter((d) => {
      return d.area === _area;
    });
    return dataFilter;
  };
  const area = getValues(`posts.${index}.area`);
  useEffect(() => {
    if (area) {
      const data = filterSubAreas(area);
      const dataSelect = buildSelectOptions(data, 'nombre', 'id').sort((a, b) => a.label.localeCompare(b.label));
      setSubareas(dataSelect);
    }
  }, [area, bunSubAreas]);

  return (
    <div className='area-5'>
      <div className='area-5-1'>
        <SelectForm
          title={t('postulant.post.area')}
          id={`posts.${index}.area`}
          data={bunAreas}
          control={control}
          formState={formState}
          isSearchable
          validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
          disabled={bunAreas.length === 0}
          onChangee={(e) => {
            const subs = buildSelectOptions(filterSubAreas(e.value), 'nombre', 'id');
            setSubareas(subs);
          }}
          errorPosition='bottom'
        />
      </div>
      <div className='area-5-2'>
        <SelectForm
          title={t('postulant.post.subarea')}
          id={`posts.${index}.subarea`}
          data={subarea}
          control={control}
          formState={formState}
          isSearchable
          validate={{ required: vacancyRequirement.jobs === vacancyRequirementType.mandatory }}
          disabled={subarea.length === 0}
          errorPosition='bottom'
        />
      </div>
    </div>
  );
};
